import React, { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import { ExtendableImage } from '@design-system/extendable-image';

import useJoiValidation from '../../hooks/useJoiValidation';
import { IProductHeaderProps } from './models';
import { productHeaderSchema } from './ProductHeader.schema';

import './ProductHeader.scss';

const ProductHeader: FC<IProductHeaderProps> = ({
  title,
  logo,
  productImage,
  backgroundImage,
  isFooter,
  description,
  subtitle,
  subtitle2,
  mobileBackgroundImage,
  layoutBackgroundImage,
  mobileLayoutBackgroundImage,
}) => {
  const {
    data,
  }: {
    data: IProductHeaderProps;
  } = useJoiValidation(productHeaderSchema, 'ProductHeader', {
    title,
    logo,
    productImage,
    backgroundImage,
    isFooter,
    description,
    subtitle,
    subtitle2,
    mobileBackgroundImage,
    layoutBackgroundImage,
    mobileLayoutBackgroundImage,
  });

  const isScreenSmall = useMediaQuery({ query: '(max-width: 650px)' });
  // useEffect(() => {
  //   if (layoutBackgroundImage) {

  //   }
  // }, [layoutBackgroundImage]);

  return (
    <div
      className={`product-header ${isFooter ? 'product-footer' : ''}`}
      // style={{ backgroundImage: `url(${layoutBackgroundImage ? layoutBackgroundImage.url : ''})` }}
    >
      <div className="product-header__background-image">
        {isFooter && (
          <div className="product-footer__link-wrapper">
            <div className="product-footer__link position-1">
              <h3 className="product-footer__title">KÜCHE</h3>
              <p className="product-footer__description">Entfernt Schmutz, Fett & Eingebranntes</p>
              <a
                href="/produkte/kueche/"
                className="cds-link cds-link--primary cds-link--primary-small"
              >
                Mehr
              </a>
            </div>
            <div className="product-footer__link position-2">
              <h3 className="product-footer__title">BAD</h3>
              <p className="product-footer__description">
                Gegen Kalkablagerungen, Schmutz und Schimmel
              </p>
              <a
                href="/produkte/bad/"
                className="cds-link cds-link--primary cds-link--primary-small"
              >
                Mehr
              </a>
            </div>
            <div className="product-footer__link position-3">
              <h3 className="product-footer__title">WC</h3>
              <p className="product-footer__description">
                Sorgt für strahlenden Glanz und hygienische Reinheit
              </p>
              <a
                href="/produkte/wc/"
                className="cds-link cds-link--primary cds-link--primary-small"
              >
                Mehr
              </a>
            </div>
          </div>
        )}
        {backgroundImage && (
          <ExtendableImage
            props={{ src: isScreenSmall ? mobileBackgroundImage.url : backgroundImage.url }}
          />
        )}
      </div>
      <div className="cds-container cds-container--max-grid">
        <div className="product-header__container">
          <div className="product-header__content">
            {logo && <ExtendableImage props={{ src: logo.url }} className="product-header__logo" />}
            <div className="product-header__text">
              {subtitle && <p className="product-header__subtitle">{subtitle}</p>}
              {title && <h2 className="product-header__title">{data.title}</h2>}
              {subtitle2 && <p className="product-header__subtitle">{subtitle2}</p>}
              {description && <p className="product-header__description">{description}</p>}
            </div>
          </div>
        </div>
        {productImage && isScreenSmall && (
          <ExtendableImage
            props={{ src: productImage.url }}
            className="product-sizes-teaser__image product-page"
          />
        )}
      </div>
    </div>
  );
};

export default ProductHeader;
